// extracted by css-extract-rspack-plugin
export default {"root":"root-ywCh3w text-xs-semibold","pill":"pill-BwI7Xg","square":"square-LvK6tP"};